import { css } from '@emotion/react';
import {
  Box,
  COLOR_PALETTE,
  SEMANTIC_BREAKPOINTS,
  desktopFirstMediaQuery,
  desktopFirstQuery,
  maxMediaQuery,
} from '@inflearn/ds-react-next';
import { useMediaQuery } from '@mantine/hooks';
import { useRef } from 'react';

import { useToggleAppShellSticky } from '../../../hooks/useToggleAppShellSticky';
import { GNB_DESKTOP_HEIGHT } from '../../../utils/size';
import { SharedButton } from './SharedButton';
import ToC from './aside/ToC';
import NoteDetailHeader from './header/NoteDetailHeader';
import NoteSection from './note/NoteSection';
import { ASIDE_TOP_MARGIN, PAGE_TOP_PADDING } from './utils/size';

export default function NoteDetail() {
  /* sticky aside */
  const offsetElementForAsideRef = useRef(null);
  const isSmallerThanDesktop = useMediaQuery(desktopFirstQuery.desktop, false);
  useToggleAppShellSticky(offsetElementForAsideRef, !isSmallerThanDesktop);

  return (
    <>
      <Box css={styleGridContainer}>
        <Box css={styleHeader}>
          <NoteDetailHeader />
        </Box>
        {/* window.scrollY 값과 비교하기 위한 static element 생성 */}
        <Box aria-hidden css={styleOffsetElementForAside} ref={offsetElementForAsideRef} />
        <Box component="aside" css={styleAside}>
          <Box css={styleFlexContainer}>
            <SharedButton />
            <ToC />
          </Box>
        </Box>
        <Box css={styleNoteSection}>
          <NoteSection />
        </Box>
      </Box>
    </>
  );
}

const styleGridContainer = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(232px, 1fr) minmax(auto, 700px) minmax(232px, 1fr)',
  gap: '40px',
  padding: `${PAGE_TOP_PADDING}px 0 96px`,
  [maxMediaQuery(SEMANTIC_BREAKPOINTS.desktop + 44)]: {
    columnGap: '16px',
  },
  [desktopFirstMediaQuery.desktop]: {
    gridTemplateColumns: '100%',
    rowGap: '16px',
    justifyItems: 'center',
  },
});

const styleHeader = css({
  gridColumn: '2',
  gridRow: '1',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  [desktopFirstMediaQuery.desktop]: {
    gridColumn: '1',
    gridRow: '1',
    width: '716px',
    maxWidth: '100%',
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: '0 16px',
  },
});

const styleOffsetElementForAside = css({
  [desktopFirstMediaQuery.desktop]: {
    gridColumn: '1',
    gridRow: '2',
  },
});

const styleAside = css({
  alignSelf: 'start',
  gridColumn: '3',
  gridRow: '1 / span 2',
  position: 'sticky',
  top: `${GNB_DESKTOP_HEIGHT + PAGE_TOP_PADDING + ASIDE_TOP_MARGIN}px`,
  zIndex: 2,

  width: '200px',
  marginRight: '32px',
  marginTop: `${ASIDE_TOP_MARGIN}px`,
  backgroundColor: 'white',
  [maxMediaQuery(SEMANTIC_BREAKPOINTS.desktop + 44)]: {
    justifySelf: 'end',
  },
  [desktopFirstMediaQuery.desktop]: {
    gridColumn: '1',
    gridRow: '3',
    top: '0',
    width: '100%',
    margin: '0',
    borderBottom: `1px solid ${COLOR_PALETTE.gray[2]}`,
  },
});

const styleFlexContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '24px',
  [desktopFirstMediaQuery.desktop]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '716px',
    maxWidth: '100%',
    margin: 'auto',
    padding: '12px 0',
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: '12px 16px',
  },
});

const styleNoteSection = css({
  gridColumn: '2',
  gridRow: '2',
  [desktopFirstMediaQuery.desktop]: {
    gridColumn: '1',
    gridRow: '4',
    width: '716px',
    maxWidth: '100%',
  },
  [desktopFirstMediaQuery.mobile]: {
    padding: '0 16px',
  },
});
